import { Package } from 'app/shared/models/booking.model';
import { DeviceService } from './../../services/device.service';
import {
    Component, OnInit, Input, ViewChild, Output, EventEmitter, OnChanges, SimpleChanges, QueryList, ViewChildren
} from '@angular/core';
import { TravelProductService, TravelPackage, FareTypeChangedEvent } from '../../services/travel-product.service';
import { Booking, Inclusion } from '../../models/booking.model';
import * as _ from 'lodash';
import { TravelDatesComponent } from './travel-dates/travel-dates.component';
import { InclusionsComponent } from './inclusions/inclusions.component';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ProductTypeUrl } from 'app/shared/models/enums/ProductTypeUrl.enum';
import { collapseAnimation } from 'app/shared/animations/collapse-animation';
import { hiddenCollapseAnimation } from 'app/shared/animations/hidden-collapse-animation';
import { Dictionary } from 'app/shared/models/dictonary.model';
import { UpdatePassengerGuidsOptions } from 'app/shared/models/events.model';
import { GxConstants } from 'app/shared/constants/gx.constants';
import { ITINERARY_CONTEXT } from 'app/shared/models/enums/context.enum';
import { ProductUrl } from '../../models/availability.model';

@Component({
    selector: 'gaweb-itinerary',
    animations: [hiddenCollapseAnimation],
    templateUrl: './itinerary.component.html'
})
export class ItineraryComponent implements OnInit, OnChanges {
    @ViewChild(TravelDatesComponent) travelDatesComponent: TravelDatesComponent;
    @ViewChildren(InclusionsComponent) inclusionsComponents: QueryList<InclusionsComponent>;
    @ViewChild('childModal') public childModal: ModalDirective;
    private _bookings: Array<Booking>;
    @Input() set bookings(value: Array<Booking>) {
        this._bookings = value;
        if (value && value.length > 0) {
            this.bootstrapComponentFromNewBookings(value);
        }
    }
    get bookings(): Array<Booking> {
        return this._bookings;
    }
    @Input() loadingBookings: boolean;

    private _showBookTravelSection: boolean;
    @Input()
    set showBookTravelSection(value: boolean) {
        this._showBookTravelSection = value;
        this.showBookTravelSectionChange.emit(value);
    }
    get showBookTravelSection(): boolean {
        return this._showBookTravelSection;
    }
    @Input() passengerCounts: Dictionary<FareTypeChangedEvent>;
    @Input()
    productUrl: ProductUrl;
    productType: ProductTypeUrl;
    @Output() showBookTravelSectionChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() onInclusionDateSaved: EventEmitter<UpdatePassengerGuidsOptions> = new EventEmitter();
    @Output() onParentBookingUpdated: EventEmitter<any> = new EventEmitter();
    
    parentBooking: Booking;
    inclusions: Array<Inclusion>;
    anythingRequired: boolean;
    someInclusionShowUsageDate: boolean;
    showTickComplete: boolean;
    inclusionsDisabled: Set<string>;
    showTravelDates: boolean;
    travelDatesCorrect: boolean;
    experienceDatesCorrectly: boolean;
    showShortTravelDatesDescription: boolean;
    isTravelOnly: boolean;
    isExperienceOnly: boolean;
    onDoLaterChecked: boolean;
    showItinerary: boolean;
    bookingGuids: string[];
    right: boolean;
    rightIcon: string;
    context: ITINERARY_CONTEXT.BOOK_NOW;
    showTypeAhead: boolean;
    @Input() loadedBooking: Booking;
    constructor(private travelPackageService: TravelProductService,
        private deviceService: DeviceService) {
        this.setShowTickComplete(false);
        this.inclusionsDisabled = new Set();
        this.showTravelDates = false;
        this.isTravelOnly = false;
        this.onDoLaterChecked = false;
    }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges){
        console.log(changes);
    }
    public isCorrectlyFilledOut() {
        return (this.showItinerary && this.showTickComplete) || !this.showItinerary;
    }
    bootstrapComponentFromNewBookings(bookings: Array<Booking>) {
        this.parentBooking = bookings[0];

        this.showTravelDates = !(!this.parentBooking || !this.parentBooking.Package ? true : !this.parentBooking.Package.ShowTravel);
        this.productType = this.productUrl.ProductTypeUrl;
        if (this.productUrl.ProductTypeUrl === ProductTypeUrl.package) {
            this.inclusions = _.sortBy(this.parentBooking.Package.Inclusions, ['SortOrder']);

            this.someInclusionShowUsageDate = false;
            let experienceDatesRequired = false;
            this.bookingGuids = [];
            const inclusionNameToTourGuids: Dictionary<string[]> = {};
            this.bookings.forEach((b: Booking) => {
                this.bookingGuids.push(b.BookingGuid);

                b.Package.Inclusions.forEach((i: Inclusion) => {
                    i.invisible = !i.FareTypes[0].ShowUsageDate;
                    const key = i.Name; // the key should identify an inclusion regardless of the faretype
                    if (!inclusionNameToTourGuids[key]) {
                        inclusionNameToTourGuids[key] = [];
                    }
                    inclusionNameToTourGuids[key].push(i.TourGuid);
                    i.tourGuids = inclusionNameToTourGuids[key];
                    this.someInclusionShowUsageDate = this.someInclusionShowUsageDate || i.FareTypes[0].ShowUsageDate;
                    experienceDatesRequired = experienceDatesRequired || i.FareTypes[0].RequiresUsageDate;
                });
            });

            this.showTypeAhead = !this.parentBooking.Package.LimitedStops;
            this.isTravelOnly = !this.someInclusionShowUsageDate && this.parentBooking.Package.ShowTravel; // showTypeAhead
            this.isExperienceOnly = this.someInclusionShowUsageDate && !this.parentBooking.Package.ShowTravel;

            const travelDatesRequired = this.parentBooking.Package.RequiresTravel;


            // this.experienceDatesCorrectly = this.someInclusionShowUsageDate ? !experienceDatesRequired : true;
            this.updateExperienceDatesCorrectly();
            this.travelDatesCorrect = this.parentBooking.Package.ShowTravel ?
                this.parentBooking.Sectors.length > 0 || this.onDoLaterChecked : true;

            this.anythingRequired = experienceDatesRequired || travelDatesRequired;
            this.showItinerary = true;
        } else { // experience
            this.inclusions = this.parentBooking.Tours;

            this.someInclusionShowUsageDate = false;
            let experienceDatesRequired = false;
            this.bookingGuids = [];
            const tourGuids = [];
            this.inclusions.forEach((i: Inclusion, idx: number) => {
                tourGuids.push(i.TourGuid);
            });
            this.inclusions.forEach((i: Inclusion, idx: number) => {
                i.tourGuids = tourGuids;
                i.invisible = idx > 0;
                this.someInclusionShowUsageDate = this.someInclusionShowUsageDate || i.FareTypes[0].ShowUsageDate;
                experienceDatesRequired = experienceDatesRequired || i.FareTypes[0].RequiresUsageDate;
            });
            this.showTypeAhead = false;
            this.isTravelOnly = false;
            this.isExperienceOnly = true;

            this.experienceDatesCorrectly = false;
            this.travelDatesCorrect = true;

            this.anythingRequired = experienceDatesRequired;
            this.showItinerary = experienceDatesRequired || this.someInclusionShowUsageDate || this.parentBooking.ShowAddTravelBtn;
        }


        this.updateTick();

        this.updateShowTravelDates();
        setTimeout(() => {
            this.showBookTravelSection = !this.isTravelOnly;
        }, 0);
        this.showShortTravelDatesDescription = this.someInclusionShowUsageDate;
    }
    onParentBookingChanged(customObj: any) {
        if (!!customObj.bookings) {
            this._bookings = customObj.bookings;
            this.parentBooking = this._bookings[0];
        }
        const inclusionsTourGuidDisabledOrEnabled: string[] = customObj.inclusionsTourGuidDisabledOrEnabled;
        const isDisabled: boolean = customObj.isDisabled;
        const inclusionDateChanged: boolean = customObj.inclusionDateChanged;
        const sectorsDeleted: boolean = customObj.sectorsDeleted;
        const removeTravelAndStartOver: boolean = customObj.removeTravelAndStartOver;

        if (isDisabled && !this.isTravelOnly && !this.isExperienceOnly) {
            // if we disable an experience (no date then), after having chosen the travel dates we have to delete them (the sectors)
            this.travelDatesComponent.deleteAllSectors(false, this._bookings, false);
        }

        if (sectorsDeleted && removeTravelAndStartOver) {
            this.clearExperiences();
        }
        if (!this.isExperienceOnly && !this.isTravelOnly && inclusionDateChanged && (this._bookings[0].Sectors != null && this._bookings[0].Sectors.length > 0)) {
            this.showModal();
        }
        this.updateInclusionsDisabled(inclusionsTourGuidDisabledOrEnabled, isDisabled);

        this.updateExperienceDatesCorrectly();
        this.updateShowTravelDates();

        this.travelDatesCorrect = this.isExperienceOnly ||
            (!this.isExperienceOnly && !this.isTravelOnly && !this.showTravelDates)
            ? true
            : (!!this.travelDatesComponent
                ? this.travelDatesComponent.isCorrect()
                : false);
        this.updateTick();
        if (!!customObj.bookings) {
            const passengers = [];

            for (const b of customObj.bookings) {
                passengers.push(b.Passengers);
            }

            const updatePassengerOptions = new UpdatePassengerGuidsOptions(_.flattenDeep(passengers));
            this.onInclusionDateSaved.emit(updatePassengerOptions);
        }
    }
    onDoLaterDateChanged({ checkValue, sectorsAdded }) {
        this.onDoLaterChecked = checkValue;
        this.updateExperienceDatesCorrectly();
        this.travelDatesCorrect = checkValue || sectorsAdded;
        this.updateTick();
    }
    onshowBookTravelSectionChanged(value: boolean) {
        this.showBookTravelSectionChange.emit(value);
    }
    private showModal() {
        this.childModal.show();
    }
    private updateInclusionsInvisibility(inclusions: Inclusion[]) {
        if (!!inclusions && !!inclusions.length && inclusions[0].invisible === undefined) {
            if (this.productUrl.ProductTypeUrl === ProductTypeUrl.package) {
                inclusions.forEach((i: Inclusion) => {
                    i.invisible = !i.FareTypes[0].ShowUsageDate;
                });
            } else {
                inclusions.forEach((i: Inclusion, idx: number) => {
                    i.invisible = idx > 0;
                });
            }
        }
    }
    closeModal() {
        this.childModal.hide();
    }
    private updateShowTravelDates() {
        const experiencesFilled = !!this._bookings[0] && !!this._bookings[0].Package ?
            this._bookings[0].Package.Inclusions.every((inclusion: Inclusion) => inclusion.SelectedDate !== GxConstants.MIN_DATE) : false;
        this.showTravelDates = this.productUrl.ProductTypeUrl === ProductTypeUrl.package &&
            ((!this.isExperienceOnly && !this.isTravelOnly && experiencesFilled) // experience and travel
                || (this.isTravelOnly)); // or only travel
    }
    private updateExperienceDatesCorrectly() {
        if ((this.parentBooking as any).length) {
            this.parentBooking = this.parentBooking[0];
            if ((this.parentBooking as any).length) {
                this.parentBooking = this.parentBooking[0];
            }
        }
        // search for the first invalid inclusion if it is not just TravelOnly
        // tslint:disable-next-line:max-line-length
        const incl = this.productUrl.ProductTypeUrl === ProductTypeUrl.package ? this.parentBooking.Package.Inclusions : this.parentBooking.Tours;
        this.updateInclusionsInvisibility(incl);
        if (this.productUrl.ProductTypeUrl === ProductTypeUrl.package) {
            this.experienceDatesCorrectly = this.isTravelOnly ? true : !incl.find((inclusion: Inclusion) =>
                inclusion.SelectedDate === GxConstants.MIN_DATE &&
                !this.inclusionsDisabled.has(inclusion.TourGuid) &&
                !inclusion.invisible);
        } else {
            // incl is a Tours array as it doesn't really contain inclusions
            this.experienceDatesCorrectly = this.isTravelOnly ? true : !incl.find((inclusion: Inclusion) =>
                inclusion.SelectedDate === GxConstants.MIN_DATE &&
                !this.inclusionsDisabled.has(inclusion.TourGuid) &&
                inclusion.ProductStatus === 1 &&
                !inclusion.invisible);
        }

    }
    private clearExperiences() {
        this.inclusionsDisabled.clear();
        this.inclusionsComponents.forEach((inclusionComponent: InclusionsComponent) => {
            inclusionComponent.reset();
        });
    }
    private updateInclusionsDisabled(inclusionTourGuidDisabledOrEnabled: string[], isDisabled: boolean): void {
        if (!!inclusionTourGuidDisabledOrEnabled && !!inclusionTourGuidDisabledOrEnabled.length) {
            inclusionTourGuidDisabledOrEnabled.forEach(guid => {
                if (isDisabled) {
                    this.inclusionsDisabled.add(guid);
                } else {
                    this.inclusionsDisabled.delete(guid);
                }
            });
        }
    }
    private updateTick() {
        this.setShowTickComplete(this.experienceDatesCorrectly && this.travelDatesCorrect);
        if (!this.deviceService.IsDesktop()) {
            this.right = this.showTickComplete;
        }
    }
    onHeaderClicked() {
        this.right = !this.right;
    }
    private setShowTickComplete(v: boolean): void {
        this.showTickComplete = v;
        this.rightIcon = v ? 'fa-inverse fa-check-circle' : 'fa-exclamation-circle fa-inverse';
    }

    doBookingUpdate(event: any){
        console.log('Do Booking Update:');
        console.log(event);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/itinerary/itinerary.component.ts